import React, { FunctionComponent } from 'react'
import CustomModal from '../CustomModal/CustomModal'
import { ExclaimIcon } from '../Icons/Icons'
import styles from './ConfirmationModal.module.css'

interface Props {
  title: string
  message: string | React.ReactNode
  yesLabel?: string
  onClose: () => void
  onYes: () => void
  cannotUndoWarning?: boolean
  showCancel?: boolean
}

const ConfirmationModal: FunctionComponent<Props> = ({
  title,
  message,
  yesLabel = 'Delete',
  onClose,
  onYes,
  cannotUndoWarning = true,
  showCancel = true,
}) => {
  const confirmAction = async () => {
    onYes()
    onClose()
  }

  return (
    <CustomModal id='popup-delete' close={onClose}>
      <form>
        <header>
          <h3 data-heap-redact-text>{title}</h3>
        </header>

        {cannotUndoWarning && (
          <div className='alert error'>
            <i className='icon-exclaim'>
              <ExclaimIcon />
            </i>

            <div className='message'>This action cannot be undone.</div>
          </div>
        )}

        <div className='content' data-heap-redact-text>
          {typeof message === 'string' || message instanceof String ? <p>{message}</p> : message}
        </div>

        <footer>
          {showCancel && (
            <button id='cancel' type='button' className='btn outline' onClick={onClose}>
              Cancel
            </button>
          )}

          <button
            id='confirm'
            type='button'
            className={`btn ${cannotUndoWarning ? `danger ${styles.danger}` : 'primary'}`}
            onClick={confirmAction}
          >
            <span className='text'>{yesLabel}</span>
          </button>
        </footer>
      </form>
    </CustomModal>
  )
}

export default ConfirmationModal
